import { pluginCoreIsTauri } from '../config';
import { managedListen, type ManagedUnlistenFn } from '../events';
import { ipcInvokeBare, ipcInvokeBinary } from '../invoke';

export const AMBIENT_TRIGGERED_EVENT = 'ambient://triggered';

export type AmbientTriggeredPayload = {
  triggerId: string;
  detectedAtMs: number;
};

const invokeIfDesktop = async (
  method: string,
  args: Record<string, unknown>
): Promise<void> => {
  if (!pluginCoreIsTauri()) {
    return;
  }
  await ipcInvokeBare(method, args);
};

export const ambientHeidi = {
  isAvailable(): boolean {
    return pluginCoreIsTauri();
  },

  setEnabled(enabled: boolean): Promise<void> {
    return invokeIfDesktop('ambient_set_enabled', { enabled });
  },

  setPaused(paused: boolean): Promise<void> {
    return invokeIfDesktop('ambient_set_paused', { paused });
  },

  onTrigger(
    handler: (payload: AmbientTriggeredPayload) => void
  ): Promise<ManagedUnlistenFn> {
    return managedListen<AmbientTriggeredPayload>(AMBIENT_TRIGGERED_EVENT, (event) => {
      handler(event.payload);
    });
  },

  takeUtterance(triggerId: string): Promise<ArrayBuffer> {
    if (!pluginCoreIsTauri()) {
      return Promise.resolve(new ArrayBuffer(0));
    }
    return ipcInvokeBinary('ambient_take_utterance', { triggerId });
  },

  cancelUtterance(triggerId: string): Promise<void> {
    return invokeIfDesktop('ambient_cancel_utterance', { triggerId });
  },
};
